<template>
  <div class="report-container">

    <!-- HEADER -->
    <div class="report-header">
      <div>
        <h1 class="report-title">Delivery Note</h1>
        <p class="report-subtitle">
          Kelola pengiriman berdasarkan tanggal & kurir.
        </p>
      </div>
    </div>
    
    <!-- FILTER -->
   <div class="report-filter single-row">

      <!-- SEARCH -->
      <input
        type="text"
        v-model="searchQuery"
        placeholder="Cari nama / HP / contact person..."
        class="search-input flex-search"
      />

      <!-- DATE -->
      <input
        type="date"
        v-model="selectedDate"
        class="filter-select"
      />

      <!-- KURIR -->
      <select v-model="selectedMethod" class="filter-select">
        <option value="">Semua Kurir</option>
        <option v-for="m in deliveryMethods" :key="m.id" :value="m.id">
          {{ m.name }}
        </option>
      </select>

      <!-- POOL -->
      <select v-model="selectedPoll" class="filter-select">
        <option value="">Semua Pool</option>
        <option v-for="p in polls" :key="p.id" :value="p.id">
          {{ p.name }}
        </option>
      </select>

      <!-- TAMPILKAN -->
      <button @click="fetchOrders" class="btn-primary">
        Tampilkan
      </button>

      <!-- ICON PRINT DELIVERY -->
      <button
        @click="printLabels"
        class="btn-icon"
        :disabled="groupedOrders.length === 0"
        title="Print Delivery Note"
      >
        <i class="bx bx-printer"></i>
      </button>

      <!-- ICON PRINT PACKING -->
      <button
        @click="printPackingStickers"
        class="btn-icon"
        :disabled="groupedOrders.length === 0"
        title="Print Packing Note"
      >
        <i class="bx bx-package"></i>
      </button>

    </div>
    <!-- SELECT ALL -->
    <div v-if="groupedOrders.length" class="mt-6">
      <div class="flex items-center mb-4">
        <input
          type="checkbox"
          v-model="selectAll"
          @change="toggleSelectAll"
          class="checkbox"
        />
        <label class="ml-2 font-medium text-gray-700">
          Pilih Semua
        </label>
      </div>

      <!-- ORDERS -->
      <div
        v-for="(group, index) in groupedOrders"
        :key="index"
        class="dn-card"
      >
        <div class="dn-row">

          <!-- checkbox -->
          <div class="dn-col-check">
            <input
              type="checkbox"
              v-model="selectedInvoices"
              :value="group.id"
              class="dn-check"
            />
          </div>

          <!-- kiri: DN info -->
          <div class="dn-col-left">
            <div class="dn-title">DN #{{ group.invoice_number }}</div>
            <div class="dn-meta">
              📅 {{ group.delivery_date }} · 🚚 {{ group.delivery_method }} · {{ group.poll }}
            </div>
          </div>

          <!-- kanan: customer -->
          <div class="dn-col-right">
            <div class="dn-name">{{ group.billing_name }}</div>
            <div class="dn-address" :title="group.address">
              {{ group.address }}
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- EMPTY -->
    <div v-else class="text-center mt-6 text-gray-500">
      Tidak ada order untuk filter ini.
    </div>
  </div>
</template>

<script>
export default {
  name: "OrdersList",

  data() {
    const today = new Date().toISOString().slice(0, 10);

    return {
      selectedDate: today,
        searchQuery: "", // ✅ INI YANG HILANG
      selectedMethod: "",
      selectedPoll: "",

      deliveryMethods: [],
      polls: [],

      orders: [],
      selectedInvoices: [],
      selectAll: false,
    };
  },
  computed: {
  groupedOrders() {
    if (!Array.isArray(this.orders)) return [];

    let filtered = this.orders;

    if (this.searchQuery && this.searchQuery.trim()) {
      const keyword = this.searchQuery.toLowerCase();

      filtered = filtered.filter(o =>
        (o.billing_name || "").toLowerCase().includes(keyword) ||
        (o.billing_phone || "").toLowerCase().includes(keyword) ||
        (o.receiver_name || "").toLowerCase().includes(keyword) ||
        (o.receiver_phone || "").toLowerCase().includes(keyword)
      );
    }

    const groups = {};

    filtered.forEach(o => {
      const key = `${o.id}_${o.invoice_number}`;

      if (!groups[key]) {
        groups[key] = {
          id: o.id,
          invoice_number: o.invoice_number,
          billing_name: o.billing_name,
          address: o.address,
          delivery_date: o.delivery_date,
          delivery_method: o.delivery_method,
          poll: o.poll,
          items: [],
        };
      }

      groups[key].items.push({
        product_name: o.product_name,
        quantity: o.quantity,
      });
    });

    return Object.values(groups);
  }
},
watch: {
  searchQuery() {
    // reset selection biar aman
    this.selectAll = false;
    this.selectedInvoices = [];
  }
},
  async mounted() {
    await this.loadFilters();
    this.fetchOrders();
  },

  methods: {
    onSearchInput() {
  // Vue akan otomatis rerender karena searchQuery berubah
  // Tapi ini dipakai supaya checkbox selection reset
  this.selectAll = false;
  this.selectedInvoices = [];
},
    toggleSelectAll() {
      this.selectedInvoices = this.selectAll
        ? this.groupedOrders.map((g) => g.id)
        : [];
    },

    async loadFilters() {
      // DELIVERY METHODS
      const mRes = await fetch("/api/delivery_methods/get_delivery_methods.php");
      const mJson = await mRes.json();
      this.deliveryMethods = mJson.data || [];

      // POLLS
      const pRes = await fetch("/api/polls/get_polls.php");
      const pJson = await pRes.json();
      this.polls = pJson.data || [];
    },

    async fetchOrders() {
      try {
        const url = new URL(
          "/api/get_orders_by_date.php",
          window.location.origin
        );

        url.searchParams.append("date", this.selectedDate);

        if (this.selectedMethod) {
          url.searchParams.append("delivery_method_id", this.selectedMethod);
        }

        if (this.selectedPoll) {
          url.searchParams.append("poll_id", this.selectedPoll);
        }

        const res = await fetch(url);
        const data = await res.json();

        if (data.status === "success") {
          this.orders = data.data || [];
        } else {
          this.orders = [];
          alert("Gagal mengambil data: " + data.message);
        }
      } catch (err) {
        console.error(err);
        alert("Terjadi kesalahan mengambil data");
      }
    },

    async printLabels() {
      if (!this.selectedInvoices.length) {
        alert("Pilih invoice dulu");
        return;
      }

      const query = this.selectedInvoices.join(",");
      window.open(`/api/print_labels_batch.php?ids=${query}`, "_blank");

      setTimeout(() => {
        this.fetchOrders();
        this.selectedInvoices = [];
        this.selectAll = false;
      }, 800);
    },
    async printPackingStickers() {
      if (!this.selectedInvoices.length) {
        alert("Pilih invoice dulu");
        return;
      }

      const query = this.selectedInvoices.join(",");
      window.open(`/api/print_packing_sticker.php?ids=${query}`, "_blank");

      setTimeout(() => {
        this.fetchOrders();
        this.selectedInvoices = [];
        this.selectAll = false;
      }, 800);
    },
    
  },
};
</script>

<style scoped>
/* ===== BASE ===== */
.report-container{
  padding:40px;
  background:#f8fafc;
  min-height:100vh;
  font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;
  color:#0f172a;
}

.report-header{
  margin-bottom:24px;
}

.report-title{
  font-size:26px;
  font-weight:650;
  letter-spacing:-.5px;
  margin-bottom:6px;
}

.report-subtitle{
  font-size:14px;
  color:#64748b;
}

/* ===== FILTER ===== */
.report-filter{
  display:flex;
  gap:12px;
  flex-wrap:wrap;
  margin-bottom:24px;
}

.search-wrap{ flex:1; min-width:240px; }

.search-input,
.filter-select{
  padding:10px 14px;
  border-radius:12px;
  border:1px solid #e2e8f0;
  background:#fff;
  font-size:14px;
}

.search-input:focus{
  outline:none;
  border-color:#6366f1;
  box-shadow:0 0 0 3px rgba(99,102,241,.12);
}

.btn-primary{
  padding:10px 16px;
  border-radius:12px;
  background:#6366f1;
  color:#fff;
  border:none;
  cursor:pointer;
  font-weight:500;
  transition:.15s ease;
}

.btn-primary:hover{
  background:#4f46e5;
  transform:translateY(-1px);
}

.btn-outline{
  padding:10px 14px;
  border-radius:12px;
  border:1px solid #e2e8f0;
  background:#fff;
  cursor:pointer;
  transition:.15s ease;
}

.btn-outline:hover{
  background:#f1f5f9;
  transform:translateY(-1px);
}

/* ===== DELIVERY CARD ===== */
.dn-card{
  background:#fff;
  border-radius:18px;
  box-shadow:0 6px 20px rgba(15,23,42,.05);
  padding:16px 18px;
  margin-bottom:14px;
  transition:.2s ease;
}

.dn-card:hover{
  transform:translateY(-2px);
  box-shadow:0 10px 28px rgba(15,23,42,.08);
}

/* GRID ROW: check | left | right  */
.dn-row{
  display:grid;
  grid-template-columns: 28px 1fr 360px; /* kanan fixed biar konsisten */
  gap:16px;
  align-items:center;
}

/* checkbox */
.dn-col-check{
  display:flex;
  justify-content:center;
}

.dn-check{
  width:18px;
  height:18px;
  accent-color:#6366f1;
  cursor:pointer;
}

/* kiri */
.dn-title{
  font-weight:700;
  font-size:15px;
  line-height:1.2;
  margin-bottom:4px;
  color:#0f172a;
}

.dn-meta{
  font-size:13px;
  color:#64748b;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

/* kanan */
.dn-col-right{
  text-align:right;
}

.dn-name{
  font-weight:700;
  color:#0f172a;
  line-height:1.2;
  margin-bottom:4px;
}

.dn-address{
  font-size:13px;
  color:#64748b;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 900px){
  .dn-row{
    grid-template-columns: 28px 1fr 280px;
  }
}

@media (max-width: 640px){
  .dn-row{
    grid-template-columns: 28px 1fr;
    grid-template-areas:
      "check left"
      "check right";
    align-items:start;
  }

  .dn-col-left{ grid-area:left; }
  .dn-col-right{
    grid-area:right;
    text-align:left;
    padding-top:6px;
  }

  .dn-meta{ white-space:normal; }
  .dn-address{ white-space:normal; }
}
/* ===== SINGLE ROW FILTER ===== */
.single-row{
  display:flex;
  gap:12px;
  align-items:center;
  flex-wrap:wrap;
}

.flex-search{
  flex:1;
  min-width:260px;
  height:44px;
}

/* Select & date */
.filter-select{
  height:44px;
  border-radius:12px;
}

/* Icon button */
.btn-icon{
  width:44px;
  height:44px;
  border-radius:12px;
  border:1px solid #e2e8f0;
  background:#fff;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  transition:.15s ease;
}

.btn-icon:hover{
  background:#f1f5f9;
  transform:translateY(-1px);
}

.btn-icon i{
  font-size:18px;
}

.btn-icon:disabled{
  opacity:.4;
  cursor:not-allowed;
  transform:none;
}

</style>
